import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { MdVisibility, MdEdit } from "react-icons/md"
import { BiExport, BiImport } from "react-icons/bi"
import ReactPaginate from 'react-paginate'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { ChangeStatus } from '../../../Components'
import Loader from '../../../Components/Loader'
import { seaConsolidationServices } from '../../../Services/seaConsolidationServices'
import locationServices from '../../../Services/locationServices'

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL
let currentPage1 = 1;
export const SeaConsolidationRateList = () => {
    const [seaConsolRateList, setSeaConsolRateList] = useState([])
    const [pagination, setPagination] = useState({ page: 1, limit: 10 })
    const [currentPage, setCurrentPage] = useState(currentPage1)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loader, setLoader] = useState(true)
    const [countryList, setCountryList] = useState([])
    const [countryValue, setCountryValue] = useState('')

    const history = useHistory()

    useEffect(() => {
        getCountryList()
    }, [])

    useEffect(() => {
        getSeaConsolRateList()
    }, [currentPage])


    const getCountryList = () => {
        let param = { page: 1, limit: 300 };
        locationServices.getCountry(param).then(res => {
            if (res.status) {
                let arry = []
                arry.push({ value: '', label: 'All country' })
                res.data.map(list => {
                    arry.push({ value: list.country_name, label: list.country_name })
                })
                setCountryList(arry)
            }
        })
    }

    const getSeaConsolRateList = (countryId = countryValue ? countryValue.label : '') => {
        let param = { ...pagination, page: currentPage }
        // if (countryId) {
        //     param['search'] = countryId
        //     param['page'] = 1
        // }
        
        if (countryId) {
            param['page'] = currentPage
            param['search'] = countryId
        }

        if (pagination.search) {
            param['search'] = pagination.search
            param['page'] = currentPage
        }
       
        seaConsolidationServices.get_cons_seafreightrats(param).then(res => {
            if (res.status) {
                setLoader(false)
                setSeaConsolRateList(res.data)
                console.log(res.data , 'airConsolidation')
                 setPagination(res.pagination)

            } else {
                setLoader(false)
            }
        })
    }

    const onModalSubmit = () => {
        let postData = {
            seafreightrats_id: isModalOpen._id,
            seafreight_status: isModalOpen.seafreight_status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        }
        seaConsolidationServices.update_cons_seafreightrats_status(postData).then(res => {
            if (res.status) {
                setIsModalOpen(false)
                getSeaConsolRateList()
            }
        })
    }
    const onSelectCountry = (e,) => {
         setCountryValue(e)
         getSeaConsolRateList(e.value)
         setCurrentPage(1)
        return (
            <>

                <div>{countryValue}</div>
            </>
        )
    }
    const onPageChangeEvent = (e) => {
        currentPage1 = e.selected + 1
        setLoader(true)
        setCurrentPage(e.selected + 1)
    }

    const onClickExport = () => {
        setLoader(true)
        seaConsolidationServices.export_seafreights_cons_data().then((res) => {
            if (res.status) {
                window.location.href = REACT_APP_API_BASEURL + "/" + res.data
                toast.success("file download successfully")
                setLoader(false)
                getSeaConsolRateList()
            
            } else {
                toast.error(res.message)
                setLoader(false)
            }
        })
    }

    const onClickImport = (e) => {
        setLoader(true)
        const formData = new FormData()
        formData.append('csv_file', e.target.files[0])
        seaConsolidationServices.import_seafreights_cons_data(formData).then((res) => {
            if (res.status) {     
                toast.success("file upload successfully")
                setLoader(false)
                getSeaConsolRateList()
                //window.location.reload();
            } else {
                toast.error(res.message)
                setLoader(false)
            }
        })
    }

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <Select
                                        styles={{
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                height: 'calc(2.15rem + 2px)',
                                                overflowY: 'visible'
                                            }),
                                            control: (provider) => ({
                                                ...provider,
                                                width: '200px',
                                                boxShadow: '0 0 0 0px #f46a6a'
                                            }),
                                            placeholder: (provider) => ({
                                                ...provider,
                                                color: '#a0b0ca'
                                            })
                                        }}
                                        placeholder="Search with country..."
                                        value={countryValue}
                                        onChange={(e) => onSelectCountry(e)}
                                        options={countryList}
                                    />
                                </div>
                                <div className="input-group pl-3 mx-2">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="search by port..."
                                        onChange={(e) => setPagination({ ...pagination, search: e.target.value })}
                                        onKeyPress={(e) => e.key === 'Enter' && getSeaConsolRateList()}
                                        onKeyUp={(e) => ((e.key === 'Backspace') && (pagination.search.length <= 0)) && getSeaConsolRateList()}
                                    ></input>
                                    <div className="input-group-prepend">
                                        <button className="input-group-text pointer search-btn" onClick={() => getSeaConsolRateList()} style={{ backgroundColor: '#e5e4ec' }}>
                                            search
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* {
                                onSelectCountry = (e) => {
                                        
                                    return (
                                        <>
                                            <div>asdfsdf</div>
                                        </>
                                    )
                                }
                            } */}
                            <div className="d-flex justify-content-end mb-3">
                                <div>
                                    <input
                                        type="file"
                                        id="upload"
                                        accept=".csv"
                                        hidden
                                        onChange={(e) => onClickImport(e)}
                                    />
                                    <label
                                        for="upload"
                                        className="btn btn-danger waves-effect waves-light mx-1 my-0"
                                    >
                                        <BiExport />
                                        Upload File
                                    </label>
                                </div>
                                <button className="btn btn-success waves-effect waves-light mx-1 my-0"
                                    onClick={() => onClickExport()}
                                >

                                    <BiImport />
                                    Download File
                                </button>
                                <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                    onClick={() => history.push('/add-sea-consolidation-rate')}
                                > <Link className="text-white" to="/add-sea-consolidation-rate" >Add SeaFreightRate</Link>
                                </button>
                            </div>

                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        <th>Destination country</th>
                                        <th>Destination Port</th>
                                        <th>Rate/cbm <small>(USD)</small> </th>
                                        <th> MinimumCBM</th>
                                        <th>AdditionalFee</th>
                                        <th>Port delivery tt</th>
                                        <th>Door delivery tt</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {seaConsolRateList.length > 0 && seaConsolRateList.map((item, key) => (
                                        <tr key={key}>
                                            <td className="text-body fw-bold">{((pagination.page - 1) * pagination.limit) + (key + 1)}</td>
                                            <td>{item.destination_country_name}</td>
                                            <td>{item.destination_city_name}</td>
                                            <td>{item.rate_per_cmb}</td>
                                            <td>{item.minimum_amount}</td>
                                            <td>{item.additional_fee}</td>
                                            <td>{item.port_delivery_tt}</td>
                                            <td>{item.door_delivery_tt}</td>

                                            <td>
                                                <span
                                                    className={"badge rounded-pill font-size-12 pointer" + (item.seafreight_status === 'ACTIVE' ? ' bg-success' : ' bg-soft-danger')}
                                                    onClick={() => setIsModalOpen(item)}
                                                >{item.seafreight_status}</span>
                                            </td>
                                            <td>
                                                <MdEdit
                                                    className="pointer"
                                                    onClick={() => history.push('/edit-sea-consolidation-rate?id=' + item._id, item)}
                                                    color="#0323fe"
                                                    size="25px"
                                                />
                                                {/* <MdVisibility
                                                    className="pointer"
                                                    onClick={() => history.push('/sea-freight-rate-details?id=' + item._id, item)}
                                                    color="#0323fe"
                                                    size="25px"
                                                /> */}
                                            </td>
                                        </tr>
                                    ))}


                                </tbody>
                            </table>
                            {seaConsolRateList.length <= 0 && !loader &&
                                <div className="text-center w-100 bg-warning my-5">
                                    <h6 className="py-2"> list not available </h6>
                                </div>
                            }
                            {seaConsolRateList.length > 0 && pagination.totalRecord > pagination.limit &&
                                <ReactPaginate
                                    previousLabel={<img src="assets/images/prev.svg" height={15} />}
                                    forcePage={currentPage - 1}
                                    nextLabel={<img src="assets/images/next.svg" height={15} />}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={(e) => onPageChangeEvent(e)}
                                    containerClassName={'pagination'}
                                    activeClassName={'active'}
                                />
                            }
                        </div>
                    </div>

                    <Loader isShow={loader} />
                </div>
                {Boolean(isModalOpen) &&
                    <ChangeStatus
                        isOpen={Boolean(isModalOpen)}
                        title='Update Status'
                        message={`Are you sure want to ${isModalOpen.seafreight_status === 'ACTIVE' ? 'Inactive' : 'Active'} status ?`}
                        onSubmitEvent={() => onModalSubmit()}
                        handleClose={() => setIsModalOpen(false)}
                    />
                }
            </div>
        </div>

    )
}
